<template>
  <el-dialog :visible.sync="show" title="选择商品" center width="800px">
    <div class="goods-search">
      <el-form size="small" :inline="true">
        <el-form-item>
          <el-input v-model="search.items_name" placeholder="请输入商品名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.number" placeholder="请输入商品编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchGoods">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="goods-con">
      <div class="goods-table">
        <el-table
          ref="multipleTable"
          :data="allItems"
          v-loading="tableLoading"
          @selection-change="handleSelectionChange"
          @row-click="clickRow"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column label="商品名称" prop="name" align="center"></el-table-column>
          <el-table-column label="商品编号" prop="number" align="center"></el-table-column>
          <el-table-column label="重量(克)" align="center">
            <div slot-scope="scope">{{scope.row.min_weight}} ~ {{scope.row.max_weight}}</div>
          </el-table-column>
          <el-table-column label="售价(元)" align="center">
            <div slot-scope="scope">{{scope.row.cost_price}}</div>
          </el-table-column>
          <el-table-column label="图片" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.image_url" width="40px;" height="40px;" />
            </template>
          </el-table-column>
        </el-table>
        <div class="goods-paging">
          <el-pagination
            @current-change="changeGoodsPage"
            :page-size="10"
            :current-page="itemsPaging.page_index"
            layout="total, prev, pager, next"
            :total="itemsPaging.total_count"
          ></el-pagination>
        </div>
      </div>
      <div class="goods-category">
        <el-tree
          :data="categoryTree"
          :props="defaultProps"
          @node-click="handleNodeClick"
          v-loading="treeLoading"
        ></el-tree>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-button @click="close">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import apis from "@/config/apis";
export default {
  data() {
    return {
      search: {
        page_index: 1,
        view: true,
        group_id: this.group,
        third_lib_id: this.server,
      },
      allItems: [],
      categoryTree: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      itemsPaging: {},
      tableLoading: false,
      treeLoading: false,
      multipleSelection: [],
    };
  },
  props: {
    show: Boolean,
    group: String,
    server: String,
  },
  mounted() {
    this.getCategoryTree();
    this.getAllItems();
    this.multipleSelection = [];
  },
  methods: {
    getCategoryTree() {
      this.treeLoading = true;
      this.$axios.get(apis.category_tree + "/1").then(res => {
        this.categoryTree = res.data.data;
        this.treeLoading = false;
      });
    },
    getAllItems() {
      this.tableLoading = true;
      this.$axios
        .get(apis.third_terminal_items, {
          params: this.search
        })
        .then(res => {
          let { data, pagination } = res.data;
          this.allItems = data;
          this.itemsPaging = pagination;
          this.search.page_index = pagination.page_index;
          this.tableLoading = false;
        });
    },
    searchGoods() {
      this.search.page_index = 1;
      this.getAllItems();
    },
    //改变树形结构
    handleNodeClick(data) {
      this.search.category_id = data.id;
      this.search.page_index = 1;
      this.getAllItems();
    },
    changeGoodsPage(page_index) {
      this.search.page_index = page_index;
      this.getAllItems();
    },
    confirm() {
      this.show = false;
    },
    close() {
      this.multipleSelection = [];
      this.show = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    clickRow(row, event, column) {
      this.multipleSelection = row;
    }
  },
  watch: {
    show: function(bl) {
      if (!bl) {
        this.$emit("close", this.multipleSelection);
      }else {
        this.getCategoryTree();
        this.getAllItems();
      }
    },
    group: function(val) {
      this.search.group_id = val;
      this.getAllItems();
    },
    server: function(val) {
      this.search.third_lib_id = val;
    }
  }
};
</script>

<style lang="scss">
.goods-con {
  display: flex;
}

.goods-table {
  flex: 3;
  border: 1px solid #e1e1e1;
}

.goods-paging {
  padding: 15px;
  text-align: right;
}

.goods-category {
  margin-left: 15px;
  flex: 1;
  border: 1px solid #e1e1e1;
  overflow: hidden;
}

.goods-category .el-tree-node__label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>